import React from 'react';
import './UsageBar.css';

function UsageBar({ label, pct }) {
  if (pct == null) return null;
  const p = Math.min(100, Math.max(0, pct));
  const hue = Math.max(0, 120 - p * 1.2);
  const color = `hsl(${hue}, 85%, 50%)`;
  const trackColor = `hsla(${hue}, 60%, 20%, 0.35)`;
  return (
    <span className="usage-bar-chip">
      <span className="usage-bar-label">{label}</span>
      <span className="usage-bar-track" style={{ backgroundColor: trackColor, boxShadow: `inset 0 0 0 1px hsla(${hue}, 50%, 30%, 0.4)` }}>
        <span className="usage-bar-fill" style={{ width: `${p}%`, backgroundColor: color, boxShadow: `0 0 6px hsla(${hue}, 85%, 50%, 0.5)` }} />
      </span>
      <span className="usage-bar-pct" style={{ color }}>{p.toFixed(1)}%</span>
    </span>
  );
}

export default UsageBar;
